import { addStyles } from 'ethcss'
import { grid, item, mediaCSS } from 'theme'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'

export const styles = {
    HeaderWrapper: {},
    HeaderWrapper__content: {
        position: 'fixed',
        top: 0,
        paddingTop: '36px',
        paddingBottom: 0,
        zIndex: 1000,
        backgroundColor: `var(--var-module-app-component-app-style-background, ${defaultThemeStyles.background})`,
        [mediaCSS.tab]: {
            left: `0 !important`,
            right: `0 !important`,
        },
        ...item.transitionErase,
    },
}

addStyles(styles)
